import { render } from "./BtnVoltarComponent.vue?vue&type=template&id=9dd29682"
import script from "./BtnVoltarComponent.vue?vue&type=script&lang=js"
export * from "./BtnVoltarComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__